var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 40H0V0H36V40Z",
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1609_3342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 24C30.9656 24 36 18.9656 36 12.75C36 11.6742 35.8453 10.6336 35.5641 9.64219C35.3461 8.88281 34.4109 8.71406 33.8555 9.26953L28.4555 14.6695C28.2445 14.8805 27.9562 15 27.6609 15H23.625C23.0062 15 22.5 14.4938 22.5 13.875V9.83906C22.5 9.54375 22.6195 9.25547 22.8305 9.04453L28.2305 3.64453C28.7859 3.08906 28.6102 2.15391 27.8578 1.93594C26.8664 1.65469 25.8258 1.5 24.75 1.5C18.5344 1.5 13.5 6.53437 13.5 12.75C13.5 14.093 13.7391 15.3867 14.168 16.582L1.39922 29.3508C0.50625 30.2438 0 31.4602 0 32.7258C0 35.3625 2.1375 37.5 4.77422 37.5C6.03984 37.5 7.25625 36.9938 8.14922 36.1008L20.918 23.332C22.1133 23.768 23.407 24 24.75 24ZM5.625 30.1875C6.07255 30.1875 6.50178 30.3653 6.81824 30.6818C7.13471 30.9982 7.3125 31.4274 7.3125 31.875C7.3125 32.3226 7.13471 32.7518 6.81824 33.0682C6.50178 33.3847 6.07255 33.5625 5.625 33.5625C5.17745 33.5625 4.74822 33.3847 4.43176 33.0682C4.11529 32.7518 3.9375 32.3226 3.9375 31.875C3.9375 31.4274 4.11529 30.9982 4.43176 30.6818C4.74822 30.3653 5.17745 30.1875 5.625 30.1875Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1609_3342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5H36V37.5H0V1.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.56e051153003d59580526fb566d58509.svg";
export { ForwardRef as ReactComponent };